import { Italiana } from "next/font/google";
import React from "react";

import { MerchandisingItem, MerchandisingRow } from "@/graphql/types/graphql";
import { Search_Type } from "@/graphql/types/graphql";
import useTracker from "@/hooks/useTracker";

import MobileCarousel from "./mobile-carousel";
import WebCarousel from "./web-carousel";

const italiana = Italiana({
  subsets: ["latin"],
  weight: "400",
});

interface HomeCarouselProps extends MerchandisingRow {
  numberPerSlide?: number;
  titleStyle?: React.CSSProperties;
  isLoop?: boolean;
  isEdits?: boolean;
  searchType?: Search_Type;
}

const HomeCarousel: React.FC<HomeCarouselProps> = ({
  title,
  titleStyle,
  items = [],
  numberPerSlide = 4,
  isLoop = true,
  isEdits = true,
  searchType,
}) => {
  const { carouselItemClickEvent } = useTracker();
  const handleItemClick = (item: MerchandisingItem) => {
    carouselItemClickEvent({
      carousel_name: title,
      item_search_query: item.searchQuery || "",
      item_text: item.text,
      brand_id: item.brandID || "",
    });
  };
  return (
    <>
      <div>
        <h2
          className={`${italiana.className} carousel-title`}
          style={titleStyle}
        >
          {title}
        </h2>
        <div className="web-carousel-section">
          <WebCarousel
            items={items}
            numberPerSlide={numberPerSlide}
            handleItemClick={handleItemClick}
            isLoop={isLoop}
            isEdits={isEdits}
            searchType={searchType}
          />
        </div>
        <div className="mobile-carousel-section">
          <MobileCarousel
            items={items}
            numberPerSlide={numberPerSlide}
            handleItemClick={handleItemClick}
            isEdits={isEdits}
            searchType={searchType}
          />
        </div>
      </div>
      <style jsx>{`
        .carousel-title {
          color: #191919;
          font-size: 36px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-align: left;
          margin-bottom: 38px;
        }

        .mobile-carousel-section {
          display: none;
        }
        @media (max-width: 768px) {
          .carousel-title {
            font-size: 24px;
            margin-bottom: 24px;
          }
          .web-carousel-section {
            display: none;
          }
          .mobile-carousel-section {
            display: block;
          }
        }
      `}</style>
    </>
  );
};

export default HomeCarousel;
